module.exports = __webpack_public_path__ + "img/base_divers_partage.623352df.svg";